<ng-container *transloco="let t">
  <div>
    <ngx-dropzone [multiple]="false" (change)="onSelect($event)">
      <ngx-dropzone-label>{{ t('sharedContent.addImage.uploadImage') }}</ngx-dropzone-label>
      <ngx-dropzone-preview
        *ngFor="let f of files"
        [removable]="true"
        (removed)="onRemove(f)">
        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
      </ngx-dropzone-preview>
    </ngx-dropzone>
    <div class="text-end mt-4">
      <button nz-button nzType="primary">
        {{ t('sharedContent.addImage.uploadBtn') }}
      </button>
    </div>
  </div>
</ng-container>